import { findIndex, isEqual } from 'lodash';

const PENDING_CALL_POLL_INTERVAL_MS = 150;
const pendingCallsList = [];

// https://stackoverflow.com/questions/6860853/generate-random-string-for-div-id
function randId() {
  return `${Date.now()}-${Math.random()
    .toString(36)
    .replace(/[^a-z]+/g, '')
    .substr(2, 10)}`;
}

const addPendingCall = (url, query) => {
  const id = randId();
  // console.devLog.info('Pending add url:', url, 'query: ', query, 'ID: ', id);
  pendingCallsList.push({
    id,
    url,
    query,
  });

  return id;
};

const removePendingCall = (id) => {
  const indexToRemove = findIndex(
    pendingCallsList,
    (pendingCall) => pendingCall.id === id,
  );

  // console.devLog.info('Item being removed: ', id);

  return pendingCallsList.splice(indexToRemove, 1);
};

const getPendingCallsForEndpoint = (
  url,
  query = undefined,
  ignoreQuery = false,
) => {
  if (ignoreQuery) {
    return pendingCallsList.filter((pendingCall) => pendingCall.url === url);
  }
  return pendingCallsList.filter(
    (pendingCall) =>
      pendingCall.url === url && isEqual(pendingCall.query, query),
  );
};

const awaitUntilPendingCallsComplete = (url, query = undefined) =>
  // Wait until the callback comes that each submit is done

  new Promise((resolve) => {
    const timerCheckSubmitted = setInterval(() => {
      if (getPendingCallsForEndpoint(url, query).length <= 0) {
        resolve();
        clearInterval(timerCheckSubmitted);
      } else {
        // console.devLog.info('Pending call polled but still outstanding', url, query);
      }
    }, PENDING_CALL_POLL_INTERVAL_MS);
  });

const awaitUntilPromiseResolves = (duration = 5000) =>
  // Wait until the callback comes that each submit is done

  new Promise((resolve) => {
    const timerCheckSubmitted = setInterval(() => {
      resolve();
      clearInterval(timerCheckSubmitted);
    }, duration);
  });

export {
  addPendingCall,
  removePendingCall,
  getPendingCallsForEndpoint,
  awaitUntilPendingCallsComplete,
  awaitUntilPromiseResolves,
};
